// export const endpointUrl = "https://myedvault.com";
// export const endpointUrl = "https://prod.saas.crest-learn.com";
export const endpointUrl = "https://test.saas.crest-learn.com";
// export const endpointUrl = "http://localhost:8000";
export const appURL = endpointUrl;
// There are plans to deprecate this...........
export const WEBSOCKET_BASE_URL =
  "http://127.0.0.1/ws/video-library/video-upload/";
export const tawkLink =
  "https://embed.tawk.to/6877fdff3606072bf84a2cf9/1j0abgbbv";
// export const tawkLink =
//   "https://tawk.to/chat/6877fdff3606072bf84a2cf9/1j0abgbbv";
